import { useState, useEffect } from "react"
import Select from 'react-select'
import api from '../../../utils/api'
import selectStyles from "../../css/SelectStyle"

// Select de município, em cascata a partir da UF escolhida (`/location/cities/:uf`,
// espelha a API pública do IBGE). Fica desabilitado até uma UF ser selecionada.
function CitySelect({ uf, value, onChange, selectName = 'city' }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!uf) {
            setOptions([])
            return
        }
        setLoading(true)
        api.get(`/location/cities/${uf}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            setOptions((response.data.cities || []).map((name) => ({ selectName, value: name, label: name })))
            setLoading(false)
        }).catch(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uf])

    const selected = value ? { value, label: value } : ''

    return (
        <Select
            options={options}
            styles={selectStyles}
            onChange={onChange}
            value={selected}
            isDisabled={!uf}
            isLoading={loading}
            placeholder={uf ? 'Cidade...' : 'Selecione a UF primeiro'}
            menuPortalTarget={document.body}
            menuPosition="fixed"
        />
    )
}

export default CitySelect
